// extracted by mini-css-extract-plugin
export default {"block":"Vm","select":"Wm","empty":"Xm","open":"Ym","error":"Zm","options":"_m","selectActive":"an","ornament":"bn"};